import axios from 'axios';

export const listTypes = (cursor, limit, success, failure) => {
    let url = "/api/v1/internal/type/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const createType = (accountId, type, success, failure) => {
    const url = "/api/v1/internal/type/";

    axios.post(url, {
        accountId: accountId,
        title: type.title,
        description: type.description,
        roles: type.roles,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const saveType = (accountId, typeId, type, success, failure) => {
    const url = `/api/v1/internal/type/${typeId}/`;

    axios.put(url, {
        accountId: accountId,
        title: type.title,
        description: type.description,
        roles: type.roles,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const deleteType = (typeId, success, failure) => {
    const url = `/api/v1/internal/type/${typeId}/`;

    axios.delete(url)
        .then(response => {
            success(typeId);
        })
        .catch(err => {
            failure(err);
        });
};
